import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/eye.svg'
import _imports_1 from '@/app/ui/assets/svg/invisible.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'


const _hoisted_1 = { class: "inline-block relative w-full" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "h-6"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "h-6"
}
const _hoisted_4 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 mr-10" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("input", {
      ref: "inputEl",
      type: "text",
      value: _ctx.displayValue,
      placeholder: _ctx.placeholder,
      autocomplete: _ctx.autocomplete,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
      onPaste: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
      class: ["block appearance-none w-full bg-white border px-4 py-3 pr-8 my-2 rounded-md shadow leading-tight focus:outline-none", {
        'border-red-lp-700': _ctx.isError,
        'border-2': !_ctx.isError
      }]
    }, null, 42, ["value", "placeholder", "autocomplete"]),
    _createVNode("button", {
      type: "button",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args))),
      class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-6 text-gray-500 focus:outline-none"
    }, [
      (_ctx.iconType === 'eye')
        ? (_openBlock(), _createBlock("img", _hoisted_2))
        : (_openBlock(), _createBlock("img", _hoisted_3))
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _hoisted_5
    ], 512), [
      [_vShow, _ctx.isError]
    ])
  ]))
}